module.exports = __webpack_public_path__ + "media/images/beauty-0d4cf7ff7543afe407655cc4f55e8016.svg";